import React from 'react';

const steps = [
  { label: 'Dane osobowe', path: '/cv-career/cv-generator/personal-info' },
  { label: 'Doświadczenie', path: '/cv-career/cv-generator/section/experience' },
  { label: 'Edukacja', path: '/cv-career/cv-generator/section/education' },
  { label: 'Języki', path: '/cv-career/cv-generator/section/languages' },
  { label: 'Sekcje dodatkowe', path: '/cv-career/cv-generator/section/bonus-info' },
  { label: 'Podsumowanie', path: '/cv-career/cv-generator/section/finalize' },
];

function CvMultiStepProgress({ currentStep }) {
  const currentIndex = steps.findIndex(s => s.label === currentStep);

  return (
    <div>
      <div className="mb-3 d-flex flex-column" style={{ gap: 18, alignItems: 'start', position: 'relative' }}>
        {steps.map((step, idx) => {
          const isActive = idx === currentIndex;
          const isCompleted = idx < currentIndex;
          return (
            <div key={step.label} style={{ position: 'relative', minHeight: 46 }} className="d-flex align-items-center gap-2">
              {/* Linie łączące */}
              {idx > 0 && (
                <span
                  style={{
                    position: 'absolute',
                    left: 14,
                    top: -28,
                    width: 2,
                    height: 56,
                    background: idx <= currentIndex ? '#ffc107' : '#e9ecef',
                    zIndex: 0,
                    borderRadius: 1,
                  }}
                />
              )}
              <span
                style={{
                  display: 'inline-flex',
                  alignItems: 'center',
                  justifyContent: 'center',
                  width: 28,
                  height: 28,
                  borderRadius: '50%',
                  background: isActive || isCompleted ? '#ffc107' : '#e9ecef',
                  color: isActive || isCompleted ? '#fff' : '#888',
                  fontWeight: 600,
                  fontSize: 15,
                  transition: 'background 0.4s cubic-bezier(.4,1.6,.6,1), color 0.4s cubic-bezier(.4,1.6,.6,1), border 0.4s cubic-bezier(.4,1.6,.6,1)',
                  zIndex: 1,
                }}
              >
                {idx + 1}
              </span>
              <span className={`fw-bold small`}
                style={{ color: (isActive || isCompleted) ? '#ffc107' : undefined }}
              >
                {step.label}
              </span>
            </div>
          );
        })}
      </div>
    </div>
  );
}

export default CvMultiStepProgress;
